import { render, staticRenderFns } from "./Moduls.vue?vue&type=template&id=0748434b"
import script from "./Moduls.vue?vue&type=script&lang=js"
export * from "./Moduls.vue?vue&type=script&lang=js"
import style0 from "./Moduls.vue?vue&type=style&index=0&id=0748434b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports